"use client";

import { PropertyOverlay } from "@/components/common/property-overlay/property-overlay";
import { ErrorBoundary } from "@/components/error-boundary";
import { useFavoritesInitialization } from "@/hooks/use-favorites";
import { useUrlState } from "@/hooks/use-url-state";
import { useSearchPageInteraction } from "@/providers/search";
import { useViewedPropertiesInitialization } from "@/providers/search/hooks/use-viewed-properties";
import React from "react";
import { SearchContentFallback } from "./fallback";
import { DesktopLayout } from "./layout/desktop";
import { MobileLayout } from "./layout/mobile";

export const Content = function Content() {
	// using a common destructured data from useSearchPageInteraction causes multiple re-renders
	const view = useSearchPageInteraction(state => state.view);
	const setView = useSearchPageInteraction(state => state.setView);

	// Initialize favorites from localStorage on mount (for buyer store)
	useFavoritesInitialization();

	// Initialize viewed properties from localStorage on mount
	useViewedPropertiesInitialization();

	// Enable URL sync for view changes
	const { setView: setUrlView } = useUrlState();

	// Create wrapper function that updates both state and URL
	const handleViewChange = React.useCallback(
		(newView: "map" | "list") => {
			setUrlView(newView);
		},
		[setUrlView],
	);

	return (
		<ErrorBoundary fallback={SearchContentFallback}>
			<div className="flex flex-col lg:flex-row w-full h-full">
				<div className="hidden md:flex w-full h-full">
					<DesktopLayout />
				</div>
				<div className="md:hidden w-full h-full relative">
					<MobileLayout view={view} onViewChange={handleViewChange} />
				</div>

				{/* Property Overlay using the new Overlay component */}
				<PropertyOverlay isForPreference={false} />
			</div>
		</ErrorBoundary>
	);
};
